var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.txs ? _c('div', {
    staticClass: "card meta"
  }, [_c('div', {
    staticClass: "table_title"
  }, [_c('span', [_vm._v(" Showing " + _vm._s(_vm.txs.length) + " Transactions of " + _vm._s(_vm.totalTransactions) + " Transactions")]), _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isStartingTransaction
    },
    on: {
      "click": _vm.back
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _c('button', {
    attrs: {
      "disabled": _vm.isLastTransaction
    },
    on: {
      "click": _vm.next
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)])]), _c('section', [_c('EVMTransactionRow', {
    attrs: {
      "txs": _vm.txs
    }
  }), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "limit_container"
  }, [_c('v-radio-group', {
    staticClass: "limit_container_group",
    attrs: {
      "id": "limit_tx",
      "items": _vm.limits,
      "label": "Limit",
      "dark": _vm.$root.theme === 'night' ? true : false,
      "dense": ""
    },
    model: {
      value: _vm.limit,
      callback: function callback($$v) {
        _vm.limit = $$v;
      },
      expression: "limit"
    }
  }, [_vm._l(_vm.limits, function (item, index) {
    return [_c('v-radio', {
      key: index,
      attrs: {
        "label": item.toString(),
        "value": item,
        "dark": _vm.$root.theme === 'night' ? true : false
      }
    })];
  })], 2)], 1), _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isStartingTransaction
    },
    on: {
      "click": _vm.back
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-left"
    }
  })], 1), _c('button', {
    attrs: {
      "disabled": _vm.isLastTransaction
    },
    on: {
      "click": _vm.next
    }
  }, [_c('fa', {
    attrs: {
      "icon": "chevron-right"
    }
  })], 1)])])], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }